import PropTypes from 'prop-types';

const ChannelType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
});

export default ChannelType;
